import { getEulasLatest, getEulas, postEulas } from '@/services';
import { message } from 'antd';

const model = {
  namespace: 'eulaModel',
  state: {
    eula: {},
    latestEula: {},
    eulas: [],
  },
  subscriptions: {},
  effects: {
    *getEulasLatest(_, { call, put }) {
      try {
        const data = yield call(getEulasLatest);
        yield put({
          type: 'setState',
          payload: {
            eula: data,
            latestEula: data,
          },
        });
      } catch (e) {
        yield put({ type: 'appModel/handleError', payload: e });
      }
    },
    *getEulas(_, { call, put }) {
      try {
        const data = yield call(getEulas);
        yield put({
          type: 'setState',
          payload: {
            eulas: data,
          },
        });
      } catch (e) {
        yield put({ type: 'appModel/handleError', payload: e });
      }
    },
    *postEulas({ payload, callback }, { call, put }) {
      try {
        yield call(postEulas, payload);

        yield put({ type: 'getEulasLatest' });
        yield put({ type: 'getEulas' });

        message.success('Success');
        callback && callback();
      } catch (e) {
        yield put({ type: 'appModel/handleError', payload: e });
      }
    },
    *onEulaSelect({ payload }, { put }) {
      try {
        yield put({
          type: 'setState',
          payload: {
            eula: payload,
          },
        });
      } catch (e) {
        console.log(e);
      }
    },
  },
};

export default model;
